import { jsx as _jsx } from "react/jsx-runtime";
import { CatUtilityNav } from '@blocks-react/components/UtilityNav';
import cx from 'classnames';
import styles from './HeaderNavSection.module.scss';
export const HeaderNavSection = ({ fullWidth, classname, children, }) => (_jsx(CatUtilityNav, { "data-testid": "cat-nav-section-search-bar", className: cx({
        [styles['header__nav-section--full-width']]: fullWidth,
    }, classname ?? ''), children: children }));
